export default __webpack_public_path__ + "static/media/sticker-1.78c2395e.png";